import { create } from 'zustand'

export type TelegramAuthStatus =
  | 'idle'
  | 'checking'
  | 'needs_linking'
  | 'authenticated'
  | 'linking'
  | 'link_failed'
  | 'error'

interface TelegramAuthState {
  /** Telegram user ID from /telegram/initiate response */
  telegramId: string | null
  /** Current authentication status */
  status: TelegramAuthStatus
  /** Error message if any */
  error: string | null
  /** Raw initData for logging/debugging purposes */
  initDataRaw: string | null

  /** Set telegram ID after initiate call */
  setTelegramId: (telegramId: string) => void
  /** Update auth status */
  setStatus: (status: TelegramAuthStatus) => void
  /** Set error */
  setError: (error: string | null) => void
  /** Store initData raw string */
  setInitDataRaw: (initData: string) => void
  /** Clear all telegram auth state */
  reset: () => void
}

const initialState = {
  telegramId: null,
  status: 'idle' as TelegramAuthStatus,
  error: null,
  initDataRaw: null,
}

export const useTelegramAuthStore = create<TelegramAuthState>((set) => ({
  ...initialState,

  setTelegramId: (telegramId: string) =>
    set({ telegramId }),

  setStatus: (status: TelegramAuthStatus) =>
    set({ status }),

  setError: (error: string | null) =>
    set({ error }),

  setInitDataRaw: (initDataRaw: string) =>
    set({ initDataRaw }),

  reset: () =>
    set(initialState),
}))
